// src/theme/index.ts
import { extendTheme } from "@chakra-ui/react";

// src/theme/colors.ts
import * as tokens from "@sequencehq/design-tokens";
var colors = {
  gray: {
    0: tokens.GreyGrey0,
    10: tokens.GreyGrey10,
    20: tokens.GreyGrey20,
    30: tokens.GreyGrey30,
    40: tokens.GreyGrey40,
    50: tokens.GreyGrey50,
    60: tokens.GreyGrey60,
    70: tokens.GreyGrey70,
    80: tokens.GreyGrey80,
    90: tokens.GreyGrey90,
    100: tokens.GreyGrey100
  },
  turquoise: {
    10: tokens.TurquoiseTurquoise10,
    20: tokens.TurquoiseTurquoise20,
    30: tokens.TurquoiseTurquoise30,
    40: tokens.TurquoiseTurquoise40,
    50: tokens.TurquoiseTurquoise50,
    60: tokens.TurquoiseTurquoise60,
    70: tokens.TurquoiseTurquoise70,
    80: tokens.TurquoiseTurquoise80,
    90: tokens.TurquoiseTurquoise90
  },
  green: {
    10: tokens.GreenGreen10,
    20: tokens.GreenGreen20,
    30: tokens.GreenGreen30,
    40: tokens.GreenGreen40,
    50: tokens.GreenGreen50,
    60: tokens.GreenGreen60,
    70: tokens.GreenGreen70,
    80: tokens.GreenGreen80,
    90: tokens.GreenGreen90
  },
  indigo: {
    10: tokens.IndigoIndigo10,
    20: tokens.IndigoIndigo20,
    30: tokens.IndigoIndigo30,
    40: tokens.IndigoIndigo40,
    50: tokens.IndigoIndigo50,
    60: tokens.IndigoIndigo60,
    70: tokens.IndigoIndigo70,
    80: tokens.IndigoIndigo80,
    90: tokens.IndigoIndigo90
  },
  pink: {
    10: tokens.RedRed10,
    20: tokens.RedRed20,
    30: tokens.RedRed30,
    40: tokens.RedRed40,
    50: tokens.RedRed50,
    60: tokens.RedRed60,
    70: tokens.RedRed70,
    80: tokens.RedRed80,
    90: tokens.RedRed90
  },
  yellow: {
    10: tokens.YellowYellow10,
    20: tokens.YellowYellow20,
    30: tokens.YellowYellow30,
    40: tokens.YellowYellow40,
    50: tokens.YellowYellow50,
    60: tokens.YellowYellow60,
    70: tokens.YellowYellow70,
    80: tokens.YellowYellow80,
    90: tokens.YellowYellow90
  },
  orange: {
    10: tokens.OrangeOrange10,
    20: tokens.OrangeOrange20,
    30: tokens.OrangeOrange30,
    40: tokens.OrangeOrange40,
    50: tokens.OrangeOrange50,
    60: tokens.OrangeOrange60,
    70: tokens.OrangeOrange70,
    80: tokens.OrangeOrange80,
    90: tokens.OrangeOrange90
  },
  purple: {
    10: tokens.PurplePurple10,
    20: tokens.PurplePurple20,
    30: tokens.PurplePurple30,
    40: tokens.PurplePurple40,
    50: tokens.PurplePurple50,
    60: tokens.PurplePurple60,
    70: tokens.PurplePurple70,
    80: tokens.PurplePurple80,
    90: tokens.PurplePurple90
  },
  red: {
    10: tokens.RedRed10,
    20: tokens.RedRed20,
    30: tokens.RedRed30,
    40: tokens.RedRed40,
    50: tokens.RedRed50,
    60: tokens.RedRed60,
    70: tokens.RedRed70,
    80: tokens.RedRed80,
    90: tokens.RedRed90
  }
};

// src/theme/components/Accordion.ts
import { theme } from "@chakra-ui/react";
var { Accordion: AccordionParts } = theme.components;
var Accordion = {
  parts: [...AccordionParts.parts],
  variants: {
    singleDisclosure: {
      button: {
        p: 0,
        svg: {
          ml: 2
        },
        _hover: {
          bg: "transparent"
        },
        _focus: {
          borderRadius: "4px",
          boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)"
        }
      },
      container: {
        border: "none",
        ".chakra-collapse": {
          overflow: "unset !important"
        }
      },
      panel: {
        pb: 0,
        px: 0,
        pt: 4
      }
    },
    templateModal: {
      button: {
        px: 0,
        py: "8px",
        _hover: {
          bg: "transparent"
        }
      },
      container: {
        border: "none"
      },
      panel: {
        py: 0,
        px: 0
      }
    }
  }
};

// src/theme/components/Button.ts
import {
  GreyGrey0 as GreyGrey02,
  GreyGrey10 as GreyGrey102,
  GreyGrey30 as GreyGrey302,
  GreyGrey40 as GreyGrey402,
  GreyGrey50 as GreyGrey502,
  GreyGrey60 as GreyGrey602,
  GreyGrey80 as GreyGrey802,
  GreyWhite,
  IndigoIndigo50 as IndigoIndigo502,
  Lato13Bold,
  Lato14Bold,
  Lato14Regular,
  OnBackgroundColoursMainLight,
  RedRed20 as RedRed202,
  RedRed40 as RedRed402,
  RedRed50 as RedRed502,
  RedRed60 as RedRed602,
  RedRed70 as RedRed702,
  RedRed80 as RedRed802,
  ShadowS,
  ShadowSEmboss,
  ShadowXs,
  TurquoiseTurquoise60 as TurquoiseTurquoise602,
  TurquoiseTurquoise70 as TurquoiseTurquoise702,
  TurquoiseTurquoise80 as TurquoiseTurquoise802,
  TurquoiseTurquoise90 as TurquoiseTurquoise902,
  IndigoIndigo60 as IndigoIndigo602
} from "@sequencehq/design-tokens";
var Button = {
  variants: {
    select: {
      borderColor: "blue.20",
      borderWidth: "1px",
      borderRadius: "18px",
      backgroundColor: "white",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "24px",
      color: "blue.200",
      _placeholder: { color: "blue.40" },
      boxSizing: "content-box",
      height: "32px",
      type: "text"
    },
    round: {
      borderColor: "blue.20",
      borderWidth: "1px",
      borderRadius: "100%",
      backgroundColor: "white",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "24px",
      color: "blue.200",
      _placeholder: { color: "blue.40" },
      boxSizing: "content-box",
      height: "32px",
      width: "32px",
      type: "text",
      padding: 0
    },
    primary: {
      ...Lato14Bold,
      borderRadius: "20px",
      backgroundColor: TurquoiseTurquoise902,
      color: OnBackgroundColoursMainLight,
      textTransform: "none",
      width: "fit-content",
      lineHeight: "16px",
      px: 6,
      py: 3,
      _hover: {
        bg: `${TurquoiseTurquoise702}`
      },
      _active: {
        bg: TurquoiseTurquoise802
      },
      _focus: {
        boxShadow: `0 0 0 2px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4,
        _hover: {
          bg: `${TurquoiseTurquoise702}`
        }
      },
      _loading: {
        _hover: {
          bg: `${TurquoiseTurquoise702}`
        }
      }
    },
    primary2: {
      ...Lato14Bold,
      borderRadius: "8px",
      border: `2px solid ${TurquoiseTurquoise802}`,
      backgroundColor: TurquoiseTurquoise802,
      color: OnBackgroundColoursMainLight,
      boxShadow: "0px -1px 1px 0px rgba(0, 0, 0, 0.16) inset, 0px 0px 3px 0px rgba(0, 0, 0, 0.04), 0px 1px 2px 0px rgba(0, 0, 0, 0.12)",
      textTransform: "none",
      width: "fit-content",
      lineHeight: "16px",
      px: "8px",
      py: 0,
      pb: "2px",
      _hover: {
        bg: `${TurquoiseTurquoise702}`,
        _disabled: {
          bg: `${TurquoiseTurquoise702}`
        }
      },
      _active: {
        bg: TurquoiseTurquoise802
      },
      _focus: {
        border: `2px solid ${TurquoiseTurquoise602}`,
        backgroundColor: TurquoiseTurquoise902,
        boxShadow: `0 0 0 1px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4,
        _hover: {
          bg: `${TurquoiseTurquoise702}`
        }
      },
      _loading: {
        _hover: {
          bg: `${TurquoiseTurquoise702}`
        }
      }
    },
    secondary: {
      ...Lato14Bold,
      borderRadius: "20px",
      backgroundColor: GreyWhite,
      color: TurquoiseTurquoise902,
      border: `1px solid ${GreyGrey402}`,
      textTransform: "none",
      width: "fit-content",
      px: 6,
      py: 3,
      _hover: {
        bg: GreyGrey102
      },
      _active: {
        bg: GreyGrey402
      },
      _focus: {
        borderColor: "transparent",
        bg: GreyWhite,
        boxShadow: `0 0 0 2px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4
      }
    },
    secondary2: {
      ...Lato14Bold,
      borderRadius: "8px",
      backgroundColor: GreyWhite,
      color: TurquoiseTurquoise902,
      border: `1px solid ${GreyGrey402}`,
      textTransform: "none",
      width: "fit-content",
      boxShadow: "0px 1px 3px 0px rgba(20, 23, 28, 0.08), 0px 0 5px 0px rgba(0, 0, 0, 0.03) inset",
      px: "12px",
      py: 0,
      _hover: {
        bg: GreyGrey102
      },
      _active: {
        bg: GreyGrey402
      },
      _focus: {
        borderColor: "transparent",
        bg: GreyWhite,
        boxShadow: `0 0 0 2px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4
      }
    },
    buttonGroup: {
      ...Lato14Bold,
      borderRadius: "8px",
      backgroundColor: GreyGrey102,
      color: GreyGrey602,
      border: `1px solid ${GreyGrey302}`,
      boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.02)",
      textTransform: "none",
      width: "fit-content",
      p: "12px",
      _notLast: {
        borderRight: "none"
      },
      _active: {
        bg: GreyWhite,
        color: IndigoIndigo502
      },
      _disabled: {
        opacity: 0.4
      }
    },
    "component-library-button-group": {
      ...Lato13Bold,
      height: "initial",
      minWidth: "initial",
      padding: "6px 10px",
      color: GreyGrey602,
      transition: "none",
      _selected: {
        bg: `${GreyWhite} !important`,
        border: "rgba(55, 66, 250, 1) 1px solid",
        position: "relative",
        borderRadius: "6px",
        zIndex: "1",
        color: "rgba(55, 66, 250, 1)",
        boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.03), 0px 1px 3px 0px rgba(0, 0, 0, 0.08)"
      },
      _active: {
        bg: GreyGrey102
      },
      _focus: {
        bg: "transparent",
        border: "none"
      },
      _hover: {
        color: IndigoIndigo502
      },
      _disabled: {
        _selected: {
          borderColor: GreyGrey402,
          color: GreyGrey602,
          _hover: {
            color: GreyGrey602
          }
        },
        _hover: {
          color: GreyGrey502
        },
        color: GreyGrey502,
        opacity: 1
      }
    },
    tertiary: {
      ...Lato14Regular,
      color: IndigoIndigo502,
      backgroundColor: "transparent",
      width: "fit-content",
      borderRadius: "none",
      px: 0,
      py: 0,
      height: "auto",
      minHeight: 0,
      _disabled: {
        opacity: 0.4
      }
    },
    ghost: {
      ...Lato14Bold,
      borderRadius: "20px",
      backgroundColor: GreyWhite,
      color: TurquoiseTurquoise902,
      border: `transparent`,
      textTransform: "none",
      width: "fit-content",
      px: 6,
      py: 3,
      _hover: {
        bg: GreyGrey102
      },
      _active: {
        bg: GreyGrey402
      },
      _focus: {
        borderColor: "transparent",
        bg: GreyWhite,
        boxShadow: `0 0 0 2px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4
      }
    },
    ghost2: {
      ...Lato14Bold,
      borderRadius: "8px",
      backgroundColor: GreyWhite,
      color: GreyGrey602,
      border: `transparent`,
      textTransform: "none",
      width: "fit-content",
      px: "12px",
      py: 0,
      _active: {
        bg: GreyGrey402
      },
      _focus: {
        borderColor: "transparent",
        bg: GreyWhite,
        boxShadow: `0 0 0 2px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4
      }
    },
    warning: {
      ...Lato14Bold,
      borderRadius: "20px",
      backgroundColor: RedRed602,
      color: OnBackgroundColoursMainLight,
      textTransform: "none",
      width: "fit-content",
      px: 6,
      py: 3,
      _hover: {
        bg: RedRed702
      },
      _active: {
        bg: RedRed802
      },
      _focus: {
        boxShadow: `0 0 0 2px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4
      }
    },
    warning2: {
      ...Lato14Bold,
      borderRadius: "8px",
      backgroundColor: RedRed602,
      borderColor: RedRed702,
      color: OnBackgroundColoursMainLight,
      textTransform: "none",
      width: "fit-content",
      px: "12px",
      py: 0,
      boxShadow: "0px 2px 2px 0px rgba(20, 23, 28, 0.08), 0px -2px 2px 0px rgba(0, 0, 0, 0.04) inset",
      _hover: {
        bg: RedRed702
      },
      _active: {
        bg: RedRed802
      },
      _focus: {
        boxShadow: `0 0 0 2px ${TurquoiseTurquoise602}`
      },
      _disabled: {
        opacity: 0.4
      }
    },
    plain: {
      height: "auto",
      borderRadius: "none"
    },
    productBack: {
      borderColor: "#A9B3C5",
      //update color with palette
      borderWidth: "1px",
      borderRadius: "24px",
      backgroundColor: "#F7F9FB",
      //update color with palette
      fontWeight: 700,
      fontSize: "14px",
      width: "72px",
      height: "40px",
      color: "#013337",
      //update color with palette
      // textTransform: 'none',
      padding: "8px 24px",
      boxShadow: "0px 1px 0px rgba(51, 61, 74, 0.24), 0px 2px 6px rgba(51, 61, 74, 0.16)"
    },
    dateSkipper: {
      backgroundColor: "white",
      fontWeight: 700,
      fontSize: "14px",
      color: "turquoise.80",
      textTransform: "none",
      _hover: {
        bg: "gray.30"
      },
      _focus: {
        zIndex: 1,
        boxShadow: "0 0 0 3px rgb(66 153 225 / 60%)"
      }
    },
    selectBulk: {
      borderRadius: "6px",
      borderWidth: "1px",
      borderColor: "gray.40",
      height: "32px",
      width: "156px",
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "16px",
      backgroundColor: "transparent",
      pl: "12px",
      pr: 0,
      textAlign: "left",
      _hover: { backgroundColor: "gray.20" },
      _active: { backgroundColor: "gray.30" },
      _focus: {
        borderWidth: "1px",
        borderColor: "turquoise.60"
      }
    },
    icon: {
      borderColor: GreyGrey402,
      borderWidth: "1px",
      borderRadius: "8px",
      boxShadow: "0 2px 2px 0 rgba(20, 23, 28, 0.08), 0 -2px 2px 0 rgba(0, 0, 0, 0.04) inset",
      _hover: {
        bg: GreyGrey102
      }
    },
    "component-library-primary": {
      ...Lato13Bold,
      background: TurquoiseTurquoise802,
      minWidth: "initial",
      height: "32px",
      boxShadow: ShadowSEmboss,
      px: "10px",
      py: "8px",
      color: GreyWhite,
      borderRadius: "6px",
      _hover: {
        boxShadow: ShadowSEmboss,
        background: TurquoiseTurquoise702,
        _disabled: {
          background: GreyGrey502,
          boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.05)"
        }
      },
      _active: {
        boxShadow: ShadowSEmboss,
        background: TurquoiseTurquoise802,
        _disabled: {
          background: GreyGrey502,
          boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.05)"
        }
      },
      _disabled: {
        opacity: 1,
        background: GreyGrey502,
        boxShadow: ShadowXs
      }
    },
    "component-library-secondary": {
      ...Lato13Bold,
      background: GreyWhite,
      minWidth: "initial",
      height: "32px",
      boxShadow: ShadowS,
      border: `${GreyGrey402} 1px solid`,
      px: "10px",
      py: "8px",
      color: GreyGrey802,
      borderRadius: "6px",
      _hover: {
        boxShadow: ShadowS,
        background: GreyGrey02,
        border: `${GreyGrey502} 1px solid`,
        _disabled: {
          border: `${GreyGrey302} 1px solid`,
          background: GreyWhite
        }
      },
      _active: {
        background: GreyGrey102,
        border: `${GreyGrey402} 1px solid`,
        boxShadow: ShadowXs
      },
      _disabled: {
        opacity: 1,
        border: `${GreyGrey302} 1px solid`,
        background: GreyWhite,
        boxShadow: ShadowXs,
        color: GreyGrey502
      }
    },
    "component-library-ghost": {
      ...Lato13Bold,
      color: IndigoIndigo502,
      padding: "8px",
      minWidth: "initial",
      height: "32px",
      borderRadius: "6px",
      border: "transparent 1px solid",
      _hover: {
        background: GreyGrey02,
        border: `${GreyGrey402} 1px solid`,
        boxShadow: ShadowS,
        _disabled: {
          border: "transparent 1px solid",
          boxShadow: "none"
        }
      },
      _active: {
        background: GreyGrey102,
        border: `${GreyGrey402} 1px solid`,
        boxShadow: ShadowXs,
        _disabled: {
          border: "transparent 1px solid",
          boxShadow: "none"
        }
      },
      _disabled: {
        opacity: 1,
        color: GreyGrey502
      }
    },
    "component-library-warning": {
      ...Lato13Bold,
      background: RedRed502,
      color: GreyWhite,
      padding: "8px",
      minWidth: "initial",
      height: "32px",
      borderRadius: "6px",
      border: `${RedRed502} 1px solid`,
      _hover: {
        background: RedRed602,
        border: `${RedRed602} 1px solid`,
        boxShadow: ShadowS,
        _disabled: {
          background: RedRed202,
          borderColor: RedRed202
        }
      },
      _active: {
        background: RedRed702,
        border: `${RedRed802} 1px solid`,
        boxShadow: ShadowXs
      },
      _disabled: {
        backgroundColor: RedRed202,
        opacity: 1,
        color: RedRed402,
        borderColor: RedRed202,
        boxShadow: ShadowXs
      }
    },
    "component-library-unstyled": {
      padding: "0px",
      minWidth: "initial",
      height: "initial",
      borderRadius: "0px"
    },
    "component-library-ai": {
      ...Lato13Bold,
      background: IndigoIndigo502,
      minWidth: "initial",
      height: "32px",
      boxShadow: ShadowSEmboss,
      px: "10px",
      py: "8px",
      color: GreyWhite,
      borderRadius: "6px",
      _hover: {
        boxShadow: ShadowSEmboss,
        background: IndigoIndigo602,
        _disabled: {
          background: GreyGrey502,
          boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.05)"
        }
      },
      _active: {
        boxShadow: ShadowSEmboss,
        background: IndigoIndigo502,
        _disabled: {
          background: GreyGrey502,
          boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.05)"
        }
      },
      _disabled: {
        opacity: 1,
        background: GreyGrey502,
        boxShadow: ShadowXs
      }
    }
  },
  sizes: {
    sm: {
      borderRadius: "20px",
      px: 4,
      height: "36px",
      padding: "10px 12px"
    },
    xs: {
      borderRadius: "8px",
      px: 8,
      height: "32px"
    }
  }
};

// src/theme/components/Checkbox.ts
var Checkbox = {
  baseStyle: {
    label: {
      display: "flex"
    },
    control: {
      bg: "white",
      _checked: {
        bg: "indigo.50",
        borderColor: "indigo.50",
        _hover: {
          bg: "indigo.50",
          borderColor: "indigo.50"
        }
      },
      _indeterminate: {
        bg: "indigo.50",
        borderColor: "indigo.50",
        _hover: {
          bg: "indigo.50",
          borderColor: "indigo.50"
        }
      },
      _disabled: {
        bg: "gray.200",
        borderColor: "gray.200"
      }
    }
  }
};

// src/theme/components/CloseButton.ts
var CloseButton = {
  variants: {
    three: {
      ...Button.variants?.three,
      width: "auto",
      textStyle: "",
      textTransform: "uppercase"
    }
  }
};

// src/theme/components/CustomSelect.ts
import { theme as theme2 } from "@chakra-ui/react";
import {
  GreyGrey80 as GreyGrey803,
  Lato13Bold as Lato13Bold2,
  Lato14Regular as Lato14Regular3
} from "@sequencehq/design-tokens";

// src/theme/formInput.ts
import * as tokens2 from "@sequencehq/design-tokens";

// src/theme/tokenCandidates.ts
import {
  GreyGrey20 as GreyGrey202,
  GreyGrey30 as GreyGrey303,
  GreyGrey40 as GreyGrey403,
  RedRed60 as RedRed603,
  IndigoIndigo50 as IndigoIndigo503
} from "@sequencehq/design-tokens";
var Shadow1 = `0 2px 4px 0 rgba(20, 23, 28, 0.08)`;
var focusedBoxShadow = `0 0 0 1px ${IndigoIndigo503}`;
var errorBoxShadow = `0 0 0 1px ${RedRed603}`;
var borderColor = GreyGrey403;
var internalBorderColor = GreyGrey303;
var inputBorderRadius = "6px";
var standardBorder = `1px solid ${borderColor}`;
var internalBorder = `1px solid ${internalBorderColor}`;
var standardHoverBackground = GreyGrey202;

// src/theme/formInput.ts
var { Lato14Regular: Lato14Regular2, RedRed60: RedRed604 } = tokens2;
var formInput = {
  ...Lato14Regular2,
  borderRadius: inputBorderRadius,
  backgroundColor: tokens2.GreyWhite,
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor,
  color: tokens2.GreyGrey100,
  boxShadow: "0px 2px 4px 0px #14171C14, 0px -2px 2px 0px #0000000A inset",
  py: 3,
  px: 3,
  height: "auto",
  _invalid: {
    borderColor: RedRed604,
    boxShadow: errorBoxShadow
  },
  _focus: {
    borderColor: tokens2.IndigoIndigo50,
    boxShadow: focusedBoxShadow
  },
  _placeholder: {
    fontWeight: tokens2.FontWeightsRegular,
    color: tokens2.GreyGrey50
  },
  _disabled: {
    opacity: 0.4
  }
};
var formInputInGroup = {
  ...Lato14Regular2,
  backgroundColor: tokens2.GreyWhite,
  color: tokens2.GreyGrey100,
  py: 3,
  px: 3,
  height: "auto",
  _placeholder: {
    fontWeight: tokens2.FontWeightsRegular,
    color: tokens2.GreyGrey50
  },
  _disabled: {
    opacity: 0.4
  },
  outline: "none"
};
var formInput2 = {
  ...Lato14Regular2,
  width: "100%",
  border: `1px solid ${tokens2.GreyGrey40}`,
  boxShadow: "0px 1px 2px 0px rgba(20, 23, 28, 0.04)",
  backgroundColor: tokens2.GreyWhite,
  _hover: {
    border: `1px solid ${tokens2.GreyGrey50}`,
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 2px 0px rgba(0, 0, 0, 0.07)"
  },
  _focus: {
    outline: `2px solid ${tokens2.IndigoIndigo50}`,
    outlineOffset: "-1px",
    boxShadow: `0px 1px 3px 0px rgba(20, 23, 28, 0.06)`
  },
  _invalid: {
    border: `1px solid ${tokens2.RedRed70}`
  }
};

// src/theme/components/CustomSelect.ts
var { Menu, Select } = theme2.components;
var CustomSelect = {
  // The parts of the component
  parts: [...Menu.parts],
  // The base styles for each part
  baseStyle: () => {
    return {
      toggleButton: {
        ...formInput
      },
      icon: {
        ...Select.baseStyle?.icon
      },
      item: {
        ...Lato14Regular3,
        width: "100%",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflowX: "auto",
        overflowY: "hidden",
        cursor: "default",
        display: "flex",
        alignItems: "center",
        color: "gray.100"
      },
      groupTitle: {
        ...Lato13Bold2,
        color: GreyGrey803
      }
    };
  },
  // The size styles for each part
  sizes: {
    ...Menu.sizes
  },
  // The variant styles for each part
  variants: {
    ...Menu.variants
  },
  // The default `size` or `variant` values
  defaultProps: {
    ...Menu.defaultProps
  }
};

// src/theme/components/Divider.tsx
import { GreyGrey30 as GreyGrey304 } from "@sequencehq/design-tokens";
var Divider = {
  baseStyle: {
    borderStyle: "solid",
    borderColor: "blue.20",
    opacity: 1
  },
  variants: {
    subtle: {
      borderColor
    },
    "component-library": {
      borderColor: GreyGrey304
    }
  }
};

// src/theme/components/Drawer.ts
var Drawer = {
  baseStyle: {
    dialog: {
      maxW: "100%",
      maxWidth: "calc((100% - 104px)/2)",
      width: "100%",
      borderLeftRadius: "8px"
    }
  },
  variants: {
    sidebar: {
      closeButton: {
        top: 4,
        right: 6
      },
      body: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        p: 5,
        width: "100%"
      },
      header: {
        display: "flex",
        alignItems: "center",
        height: "64px",
        borderBottomWidth: "1px",
        borderColor: "gray.40",
        borderStyle: "solid",
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "24px",
        py: 5
      },
      footer: {
        display: "flex",
        flex: "0",
        bg: "white",
        alignItems: "center",
        borderBottomLeftRadius: "8px",
        height: "64px",
        borderTopWidth: "1px",
        borderColor: "gray.40",
        borderStyle: "solid",
        fontWeight: "700",
        fontSize: "16px",
        position: "sticky",
        bottom: 0,
        py: 3,
        px: 6
      }
    }
  },
  sizes: {
    md: {
      dialog: {
        maxW: "460px",
        maxWidth: "460px",
        width: "460px"
      }
    },
    lg: {
      dialog: {
        maxW: "480px",
        maxWidth: "480px",
        width: "480px"
      }
    },
    "depth-1": {
      dialog: {
        maxWidth: "calc((100% - 80px)/2)",
        maxHeight: "calc((100vh - 24px))",
        marginTop: "12px"
      }
    }
  }
};

// src/theme/components/FormLabel.ts
var FormLabel = {
  baseStyle: {
    fontSize: "14px",
    fontWeight: 700,
    mb: 0
  }
};

// src/theme/components/IconButton.ts
var IconButton = {
  variants: {
    clear: {
      backgroundColor: "transparent",
      _hover: {
        backgroundColor: "transparent"
      }
    }
  }
};

// src/theme/components/Input.ts
import {
  GreyGrey50 as GreyGrey504,
  GreyGrey70 as GreyGrey702,
  GreyWhite as GreyWhite3,
  GreyGrey80 as GreyGrey804,
  GreyGrey40 as GreyGrey405,
  Lato13Regular,
  GreyGrey90 as GreyGrey902,
  IndigoIndigo50 as IndigoIndigo505,
  GreyGrey30 as GreyGrey305,
  GreyGrey10 as GreyGrey103
} from "@sequencehq/design-tokens";
var Input = {
  baseStyle: {
    field: {
      "data-1p-ignore": "true",
      "data-lpignore": "true"
    }
  },
  variants: {
    "sequence-form": {
      field: {
        ...formInput
      },
      addon: {
        color: "green",
        bg: "blue"
      }
    },
    "input-in-group": {
      field: {
        ...formInputInGroup
      },
      addon: {
        color: GreyGrey702,
        bg: GreyWhite3,
        px: 3,
        svg: {
          width: "16px",
          height: "16px"
        }
      },
      element: {
        height: "100%",
        left: 2,
        color: GreyGrey504
      }
    },
    "input-in-group-2": {
      field: {
        ...formInputInGroup
      },
      addon: {
        color: GreyGrey702,
        bg: GreyWhite3,
        px: 3,
        svg: {
          width: "16px",
          height: "16px"
        }
      },
      element: {
        height: "100%",
        left: 2,
        color: GreyGrey804
      }
    },
    plain: {
      border: "none",
      outline: "none"
    },
    headline: {
      field: {
        borderRadius: 0,
        border: "none",
        color: "gray.70",
        fontWeight: 700,
        fontSize: "20px",
        lineHeight: "24px",
        px: 2
      }
    },
    "table-cell": {
      field: {
        padding: 4,
        borderRadius: 0,
        height: "56px",
        textAlign: "right"
      },
      addon: {
        mt: "0px",
        paddingLeft: "2px",
        lineHeight: "19px",
        height: "56px"
      }
    },
    formInput2: {
      field: {
        ...formInput2
      }
    },
    "component-library": {
      field: {
        ...Lato13Regular,
        outline: "none",
        height: "32px",
        border: `${GreyGrey405} 1px solid`,
        paddingLeft: "12px",
        paddingRight: "12px",
        color: GreyGrey902,
        backgroundColor: GreyWhite3,
        boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.05)",
        borderRadius: "6px",
        _placeholder: {
          color: GreyGrey504
        },
        _focus: {
          border: `${IndigoIndigo505} 1px solid`
        },
        _disabled: {
          opacity: 1,
          boxShadow: "none",
          border: `${GreyGrey305} 1px solid`,
          color: GreyGrey504,
          background: GreyGrey103
        }
      }
    }
  },
  sizes: {
    md: {
      field: {
        height: "40px",
        borderRadius: "6px"
      }
    },
    sm: {
      field: {
        height: "36px",
        borderRadius: "8px"
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/theme/components/Link.ts
var Link = {
  variants: {
    navigation: {
      width: "100%",
      height: "40px",
      maxHeight: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      _hover: {
        textDecoration: "none"
      },
      _activeLink: {
        backgroundColor: "grey.400"
      }
    },
    navigationOld: {
      width: "100%",
      height: "80px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderColor: "red.500",
      padding: "5px 0",
      cursor: "pointer",
      _hover: {
        textDecoration: "none"
      },
      _activeLink: {
        backgroundColor: "grey.400"
      }
    },
    bottomNavigation: {
      width: "100%",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderColor: "red.500",
      padding: "5px 0",
      _hover: {
        textDecoration: "none"
      },
      _activeLink: {
        backgroundColor: "grey.400"
      }
    },
    inline: {
      color: "indigo.50",
      _hover: {
        textDecoration: "none"
      }
    }
  }
};

// src/theme/components/List.ts
var List = {
  variants: {
    "template-modal": {
      item: {
        "&::marker": {
          color: "gray.80",
          fontSize: "14px",
          lineHeight: "24px",
          fontWeight: 700
        },
        flexDirection: "column",
        spacing: "4px"
      }
    }
  }
};

// src/theme/components/Menu.ts
import {
  GreyGrey20 as GreyGrey203,
  GreyGrey30 as GreyGrey306,
  GreyGrey40 as GreyGrey406,
  GreyGrey80 as GreyGrey805,
  GreyWhite as GreyWhite4,
  IndigoIndigo50 as IndigoIndigo506,
  Lato13Regular as Lato13Regular2,
  Lato14Bold as Lato14Bold2
} from "@sequencehq/design-tokens";
var Menu2 = {
  baseStyle: {
    button: {
      ...Lato14Bold2,
      borderRadius: "6px",
      _focus: {
        boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)"
      }
    },
    list: {
      borderRadius: "6px",
      padding: "0",
      zIndex: 1
    },
    item: {
      borderRadius: "6px",
      _hover: {
        borderRadius: "6px"
      },
      _focus: {
        backgroundColor: "#F1F4F8"
      },
      _active: {
        backgroundColor: "#F1F4F8"
      }
    }
  },
  variants: {
    select: {
      item: {
        px: "16px",
        py: "20px"
      }
    },
    kebab: {
      button: {
        borderRadius: "50%",
        width: "24px",
        height: "24px",
        minWidth: "24px",
        maxWidth: "24px",
        maxHeight: "24px",
        backgroundColor: "transparent",
        _hover: {
          backgroundColor: borderColor
        },
        _active: {
          backgroundColor: "gray.40"
        }
      }
    },
    "component-library": {
      list: {
        background: GreyWhite4,
        borderRadius: "8px",
        border: `${GreyGrey406} 1px solid`,
        boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.08)",
        padding: "4px"
      },
      button: {
        ...Lato14Bold2,
        borderRadius: "6px",
        _focus: {
          outline: `2px solid ${IndigoIndigo506}`,
          outlineOffset: 0
        }
      },
      item: {
        ...Lato13Regular2,
        padding: "8px",
        color: GreyGrey805,
        transition: "none",
        marginBottom: 1,
        _hover: {
          backgroundColor: GreyGrey203
        },
        _active: {
          backgroundColor: `${IndigoIndigo506} !important`,
          color: GreyWhite4
        },
        _disabled: {
          _active: {
            backgroundColor: `${GreyGrey203} !important`,
            color: GreyGrey805
          }
        }
      },
      divider: {
        borderColor: GreyGrey306,
        position: "relative",
        left: "-4px",
        width: "calc(100% + 8px)",
        my: "4px"
      }
    }
  }
};

// src/theme/components/Modal.ts
import { GreyGrey30 as GreyGrey307, Lato16Bold } from "@sequencehq/design-tokens";
var Modal = {
  baseStyle: {
    header: {
      textStyle: "header1",
      fontWeight: 700,
      fontSize: "24px",
      lineHeight: "29px",
      flex: 1
    },
    dialog: {
      margin: "32px",
      borderRadius: "24px"
    },
    footer: {
      borderColor,
      borderTopWidth: "1px",
      height: "72px"
    }
  },
  sizes: {
    exports: {
      dialog: {
        width: "100%",
        maxWidth: "900px",
        height: "100%",
        maxHeight: "524px"
      }
    }
  },
  variants: {
    v2: {
      dialog: {
        minWidth: "490px",
        padding: 0,
        borderRadius: "8px",
        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08)"
      },
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.24)"
      },
      header: {
        borderBottom: `1px solid ${GreyGrey307}`,
        ...Lato16Bold
      },
      footer: {
        height: "auto",
        padding: 3,
        gap: 2,
        justifyContent: "flex-end"
      }
    }
  }
};

// src/theme/components/MultiSelect.ts
import { theme as theme3 } from "@chakra-ui/react";
var { Menu: Menu3 } = theme3.components;
var MultiSelect = {
  // The parts of the component
  parts: [...Menu3.parts],
  // The base styles for each part
  baseStyle: () => ({
    list: {
      ...Menu3.baseStyle?.list
    }
  }),
  // The size styles for each part
  sizes: {
    ...Menu3.sizes
  },
  // The variant styles for each part
  variants: {
    ...Menu3.variants
  },
  // The default `size` or `variant` values
  defaultProps: {
    ...Menu3.defaultProps
  }
};

// src/theme/components/Popover.ts
import { Lato14Regular as Lato14Regular4 } from "@sequencehq/design-tokens";
var Popover = {
  variants: {
    downshift: {
      content: {
        border: standardBorder,
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.16)",
        bg: "white",
        py: 2
      },
      body: {
        p: 0
      }
    },
    dateInput: {
      popper: {
        width: "auto"
      },
      content: {
        border: "none"
      },
      body: {
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.16)",
        p: 4,
        bg: "white"
      }
    },
    dateRange: {
      popper: {
        width: "fit-content"
      },
      content: {
        border: "none",
        width: "fit-content"
      },
      body: {
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.16)",
        p: 4,
        bg: "white",
        width: "fit-content"
      }
    },
    fieldInfo: {
      header: {
        borderBottomWidth: 0,
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 700,
        pt: 5,
        px: 4,
        pb: 2
      },
      body: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 400,
        pt: 0,
        px: 4,
        pb: 5
      },
      content: {
        borderRadius: "8px",
        maxWidth: "300px"
      }
    },
    info: {
      header: {
        ...Lato14Regular4
      },
      body: {
        ...Lato14Regular4,
        lineHeight: "20px",
        padding: 3,
        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08)"
      },
      content: {
        width: "auto"
      }
    },
    unstyled: {
      content: {
        borderRadius: "0px",
        border: "none",
        background: "transparent",
        width: "fit-content"
      }
    }
  }
};

// src/theme/components/Progress.ts
import * as tokens3 from "@sequencehq/design-tokens";
var Progress = {
  baseStyle: {
    filledTrack: {
      bg: tokens3.BackgroundColoursCtaBackgroundColour
    },
    track: {
      bg: "gray.50"
    }
  }
};

// src/theme/components/Radio.ts
var Radio = {
  variants: {
    descriptionGroup: {
      control: {
        borderRadius: "14px",
        _checked: {
          bg: "indigo.50",
          color: "white",
          borderColor: "indigo.50"
        }
      }
    }
  }
};

// src/theme/components/Select.ts
var Select2 = {
  variants: {
    "sequence-form": {
      field: {
        ...formInput
      }
    }
  }
};

// src/theme/components/Stat.ts
var Stat = {
  variants: {
    one: {
      container: {
        borderRight: "1px solid",
        borderColor
      }
    },
    two: {
      container: {
        px: 5,
        py: 4,
        border: "1px solid",
        borderColor: "blue.20",
        rounded: "sm",
        backgroundColor: "white",
        height: "5.75rem",
        borderRadius: "4px"
      }
    }
  }
};

// src/theme/components/Switch.ts
import {
  GreenGreen60 as GreenGreen602,
  GreyGrey50 as GreyGrey505,
  IndigoIndigo50 as IndigoIndigo507,
  RedRed60 as RedRed605
} from "@sequencehq/design-tokens";
var Switch = {
  defaultProps: {
    variant: "default",
    size: "sm"
  },
  variants: {
    activeInactive: {
      container: {
        bg: "none"
      },
      track: {
        bg: GreyGrey505,
        _checked: {
          bg: GreenGreen602
        }
      }
    },
    warning: {
      container: {
        bg: "none"
      },
      track: {
        bg: GreyGrey505,
        _checked: {
          bg: RedRed605
        }
      }
    },
    default: {
      track: {
        bg: GreyGrey505,
        _checked: {
          bg: IndigoIndigo507
        }
      },
      thumb: {
        bgGradient: "linear-gradient(180deg, #FFF 46.88%, #F0F6FD 100%)",
        boxShadow: "0px 2px 4px 0px rgba(20, 23, 28, 0.04)"
      }
    }
  },
  sizes: {
    sm: {
      track: {
        width: "24px"
      },
      thumb: {
        _checked: {
          transform: "translateX(12px)"
        }
      }
    },
    md: {
      track: {
        width: "32px"
      },
      thumb: {
        _checked: {
          transform: "translateX(16px)"
        }
      }
    }
  }
};

// src/theme/components/Table.ts
import {
  GreyGrey10 as GreyGrey104,
  GreyGrey30 as GreyGrey308,
  GreyGrey60 as GreyGrey603,
  GreyGrey70 as GreyGrey703,
  GreyWhite as GreyWhite5,
  Lato13Bold as Lato13Bold3,
  Lato13Regular as Lato13Regular3
} from "@sequencehq/design-tokens";
var Table = {
  variants: {
    virtual: {
      table: {
        backgroundColor: "white",
        borderCollapse: "separate",
        borderSpacing: 0
      },
      th: {
        p: 0,
        whiteSpace: "nowrap",
        fontWeight: 700,
        fontSize: "14px",
        textTransform: "none",
        color: "gray.80",
        backgroundColor: "#F1F4F8",
        letterSpacing: "none"
      },
      tr: {
        _hover: {
          backgroundColor: "gray.10"
        },
        _notLast: {
          td: {
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            borderBottomColor: borderColor
          }
        }
      },
      td: {
        overflow: "hidden",
        px: 4,
        py: 4,
        lineHeight: "24px",
        fontWeight: 400,
        fontSize: "14px",
        color: "gray.80",
        bg: "transaprent"
      },
      thead: {
        top: 0,
        position: "sticky",
        backgroundColor: "white",
        zIndex: 3
      }
    },
    direct: {
      table: {
        borderCollapse: "separate",
        borderSpacing: 0,
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: borderColor
      },
      th: {
        p: 0,
        whiteSpace: "nowrap",
        fontWeight: 700,
        fontSize: "14px",
        textTransform: "none",
        color: "gray.80",
        backgroundColor: "#F1F4F8",
        _notLast: {
          borderRight: "1px solid white"
        }
      },
      tr: {
        _notLast: {
          td: {
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            borderBottomColor: borderColor
          }
        }
      },
      td: {
        p: 0,
        _notLast: {
          borderRight: "1px solid white"
        }
      },
      thead: {
        top: 0,
        position: "sticky",
        backgroundColor: "white"
      }
    },
    lineItemGroup: {
      table: {
        tableLayout: "fixed"
      },
      th: { padding: 0 },
      td: { padding: 0 }
    },
    simple: {
      table: {
        tableLayout: "fixed"
      },
      th: { px: 0, py: 2 },
      td: { px: 0, py: 2, border: "none" }
    },
    v2: {
      table: {
        tableLayout: "fixed"
      },
      thead: {
        height: "36px",
        tr: {
          borderBottom: `1px solid ${GreyGrey308}`
        },
        th: {
          ...Lato13Bold3,
          textTransform: "none",
          color: GreyGrey603,
          backgroundColor: GreyGrey104,
          padding: "10px 12px",
          letterSpacing: "0.12px"
        }
      },
      tfoot: {
        height: "36px",
        tr: {
          borderTop: `1px solid ${GreyGrey308}`
        },
        td: {
          /**
           * We don't want to include the fontWeight here, as it makes it tedious
           * to then define locally when we want to set it differently (which we
           * often do in footers, where one column may be bold, and another semibold)
           */
          fontSize: Lato13Regular3.fontSize,
          lineHeight: Lato13Regular3.lineHeight,
          fontFamily: Lato13Regular3.fontFamily,
          color: GreyGrey703,
          textTransform: "none",
          backgroundColor: GreyWhite5,
          padding: "10px 12px",
          letterSpacing: "0.12px"
        }
      },
      tbody: {
        color: GreyGrey703,
        tr: {
          borderBottom: `1px solid ${GreyGrey308}`,
          cursor: "pointer",
          _hover: {
            backgroundColor: GreyGrey104
          },
          _last: {
            borderBottom: "none"
          }
        },
        td: {
          height: "36px",
          ...Lato13Regular3,
          padding: "10px 12px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }
    },
    "v2-without-hover": {
      table: {
        tableLayout: "fixed"
      },
      thead: {
        tr: {
          borderBottom: `1px solid ${GreyGrey308}`
        },
        th: {
          ...Lato13Bold3,
          textTransform: "none",
          color: GreyGrey703,
          padding: "10px 12px",
          letterSpacing: "0.12px",
          backgroundColor: GreyGrey104
        }
      },
      tfoot: {
        height: "36px",
        tr: {
          borderTop: `1px solid ${GreyGrey308}`
        },
        td: {
          /**
           * We don't want to include the fontWeight here, as it makes it tedious
           * to then define locally when we want to set it differently (which we
           * often do in footers, where one column may be bold, and another semibold)
           */
          fontSize: Lato13Regular3.fontSize,
          lineHeight: Lato13Regular3.lineHeight,
          fontFamily: Lato13Regular3.fontFamily,
          color: GreyGrey703,
          textTransform: "none",
          backgroundColor: GreyWhite5,
          padding: "10px 12px",
          letterSpacing: "0.12px"
        }
      },
      tbody: {
        color: GreyGrey703,
        tr: {
          borderBottom: `1px solid ${GreyGrey308}`,
          _last: {
            borderBottom: "none"
          }
        },
        td: {
          height: "36px",
          ...Lato13Regular3,
          padding: "6px 12px",
          whiteSpace: "nowrap",
          overflow: "hidden"
        }
      }
    },
    totals: {
      table: {
        tableLayout: "fixed"
      },
      th: { px: 0, py: 2 },
      td: { px: 0, py: 1, border: "none" }
    }
  }
};

// src/theme/components/Tabs.ts
var Tabs = {
  variants: {
    line: {
      tablist: {
        borderBottomWidth: "1px"
      },
      tab: {
        height: "50px",
        textStyle: "sidebarRegular",
        borderBottomWidth: "4px",
        borderColor: "transparent",
        _active: {
          background: "transparent"
        },
        _selected: {
          color: "blue.300",
          textStyle: "sidebarBold",
          borderColor: "green.100"
        },
        _first: {
          borderTopLeftRadius: "8px",
          borderBottomLeftRadius: "8px"
        },
        _last: {
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px"
        }
      },
      tabpanel: {
        padding: 5
      }
    },
    "soft-rounded": {
      tab: {
        color: "blue.40",
        py: 1,
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "24px",
        textTransform: "uppercase",
        _selected: {
          backgroundColor: "green.80",
          fontWeight: 700,
          color: "blue.200"
        }
      }
    },
    "new-rounded": {
      tablist: {
        borderBottomWidth: "1px",
        bg: "gray.30",
        height: "48px",
        borderRadius: "24px",
        padding: "8 24px",
        boxShadow: "inset 0px 1px 2px rgba(31, 45, 96, 0.25), inset 0px 2px 6px rgba(28, 68, 104, 0.06)"
      },
      tab: {
        color: "gray.70",
        width: "115px",
        py: 1,
        fontSize: "14px",
        lineHeight: "24px",
        rounded: "full",
        margin: "4px",
        fontWeight: 700,
        _selected: {
          backgroundColor: "white",
          color: "gray.100",
          borderColor,
          borderWidth: "1px",
          borderStyle: "solid",
          boxShadow: "0px 2px 6px 0px #333D4A29, 0px 1px 0px 0px #333D4A3D"
        },
        _hover: {
          backgroundColor: "#F1F4F8"
        }
      }
    },
    "select-tabs": {
      tablist: {
        backgroundColor: "white",
        borderWidth: "1px",
        borderColor: "gray.40",
        borderRadius: "8px"
      },
      tab: {
        color: "gray.100",
        borderRightColor: "gray.40",
        borderRightWidth: "1px",
        padding: "8px 16px",
        _active: {
          background: "turquoise.80",
          color: "white",
          _first: {
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px"
          },
          _last: {
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px"
          }
        },
        _selected: {
          color: "white",
          background: "turquoise.80",
          borderColor: "gray.40",
          _first: {
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px"
          },
          _last: {
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px"
          },
          icon: {
            color: "white"
          }
        }
      }
    },
    "customer-portal": {
      tablist: {
        height: "40px"
      },
      tab: {
        padding: "12px 8px",
        fontSize: "14px",
        lineHeight: "16px",
        borderBottomColor: borderColor,
        borderBottomWidth: "1px",
        fontWeight: 400,
        _selected: {
          borderBottomColor: "gray.100",
          borderBottomWidth: "1px",
          borderStyle: "solid",
          fontWeight: 700
        }
      }
    },
    "modal-tabs": {
      tablist: {
        height: "48px",
        px: "28px"
      },
      tab: {
        padding: "12px 16px",
        fontSize: "14px",
        lineHeight: "16px",
        fontWeight: 400,
        _selected: {
          borderBottomColor: "gray.100",
          borderBottomWidth: "1.5px",
          borderStyle: "solid",
          fontWeight: 700
        },
        _hover: {
          color: "gray.100"
        }
      }
    }
  }
};

// src/theme/textStyles.ts
import * as tokens4 from "@sequencehq/design-tokens";
var textStyles = {
  default: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "gray.100"
  },
  bold: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "16px",
    color: "gray.100"
  },
  boldLarge: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    color: "gray.100"
  },
  header1: {
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: "48px"
  },
  header2: {
    fontWeight: 400,
    fontSize: "28px",
    lineHeight: "34px"
  },
  header3: {
    fontWeight: 300,
    fontSize: "20px",
    lineHeight: "30px"
  },
  mainText: {
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px"
  },
  sidebarBold: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    color: "blue.200"
  },
  sidebarRegular: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "16px",
    color: "gray.100"
  },
  sidebarSubNav: {
    color: "gray.100",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "16px"
  },
  tableTextBold: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px"
  },
  tableTextRegular: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px"
  },
  ctaLarge: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "24px"
  },
  ctaSmall: {
    fontWeight: 700,
    fontSize: "12px",
    lineHeight: "24px"
  },
  feature: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px"
  },
  formTitle: {
    fontSize: "32px",
    fontWeight: 700
  },
  previewTitle: {
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "80px"
  },
  previewLabel: {
    fontSize: "14px",
    fontWeight: 700
  },
  previewText: {
    fontSize: "14px",
    fontWeight: 400
  },
  formLabel: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "16px",
    color: "gray.100"
  },
  billingScheduleFormLabel: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "20px",
    color: "gray.100"
  },
  formSubTitle: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "20px",
    color: "gray.100"
  },
  planTotal: {
    fontSize: "40px",
    lineHeight: "48px",
    color: "gray.100"
  },
  addProductButton: {
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "24px",
    color: "turquiose.60"
  },
  titleBar: {
    fontWeight: "700",
    fontSize: "16px",
    color: "gray.100"
  },
  hint: {
    color: "gray.60",
    fontSize: "13px",
    fontWeight: "400"
  },
  sectionHeader: {
    fontSize: "18px",
    fontWeight: "700",
    color: "gray.100"
  },
  productDescription: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "14px"
  },
  infoText: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "gray.70"
  },
  infoTextBold: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px",
    color: "gray.70"
  },
  taxInfoText: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "gray.100"
  },
  taxRateProductHeading: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "17px"
  },
  note: {
    color: "gray.60",
    fontSize: "12px",
    fontWeight: "400"
  },
  tableHeader: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "17px",
    color: "gray.60"
  },
  invoiceBottomContent: {
    fontWeight: 400,
    fontSize: "20px",
    color: "gray.70"
  },
  invoicePaymentTitle: {
    fontWeight: 400,
    fontSize: "12px",
    color: "gray.70"
  },
  invoicePaymentContent: {
    fontWeight: 700,
    fontSize: "12px",
    color: "gray.70",
    textAlign: "right",
    width: "100%"
  },
  toastTitle: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "gray.90"
  },
  toastDescription: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "gray.90"
  },
  toastLink: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "indigo.60"
  },
  accordionButtonTitle: {
    color: "gray.100",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px"
  },
  accordionBodyTitle: {
    color: "gray.100",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "28px"
  },
  accordionBodyDescription: {
    fontSize: "16px",
    lineHeight: "24px"
  },
  eyebrow: {
    ...tokens4.Lato12Regular,
    color: tokens4.GreyGrey60,
    textTransform: "uppercase"
  },
  columnHeading: {
    color: tokens4.GreyGrey60,
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "16px"
  },
  pageTitle: {
    color: tokens4.GreyGrey100,
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "24px"
  },
  emptyStateTitle: {
    color: "gray.100",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "24px"
  },
  emptyStateDescription: {
    color: "gray.100",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px"
  },
  ctaCardDescription: {
    color: "gray.60",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px"
  },
  errorPageTitle: {
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: "64px"
  },
  orderedList: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    color: "gray.80"
  },
  accordionTitle: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "16px",
    color: "gray.80"
  },
  accordionDescription: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "gray.80"
  },
  link: {
    fontSize: "14px",
    color: "indigo.50"
  },
  widgetTitle: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "gray.100"
  },
  lato12Regular: tokens4.Lato12Regular,
  lato12Bold: tokens4.Lato12Bold,
  lato13Regular: tokens4.Lato13Regular,
  lato13Bold: tokens4.Lato13Bold,
  lato14Regular: tokens4.Lato14Regular,
  lato14Bold: tokens4.Lato14Bold,
  lato16Regular: tokens4.Lato16Regular,
  lato16Bold: tokens4.Lato16Bold,
  lato20Regular: tokens4.Lato20Regular,
  lato20Bold: tokens4.Lato20Bold,
  lato24Regular: tokens4.Lato24Regular,
  lato24Bold: tokens4.Lato24Bold,
  lato28Regular: tokens4.Lato28Regular,
  lato28Bold: tokens4.Lato28Bold,
  lato32Regular: tokens4.Lato32Regular,
  lato32Bold: tokens4.Lato32Bold,
  lato40Regular: tokens4.Lato40Regular,
  lato40Bold: tokens4.Lato40Bold
};

// src/theme/components/Text.ts
var isTextStyleKey = (textStyle) => {
  return typeof textStyle === "string" && textStyle in textStyles;
};
var Text = {
  baseStyle: ({ textStyle }) => {
    const textStyleKey = isTextStyleKey(textStyle) ? textStyle : "default";
    return textStyles[textStyleKey];
  }
};

// src/theme/components/Textarea.ts
var Textarea = {
  variants: {
    "sequence-form": {
      ...formInput
    }
  }
};

// src/theme/index.ts
var theme4 = extendTheme({
  colors: {
    main: "#2E2C34",
    ...colors
  },
  fonts: {
    body: `Lato, sans-serif`,
    heading: `Lato, sans-serif`
  },
  textStyles,
  components: {
    Accordion,
    Button,
    Checkbox,
    CloseButton,
    CustomSelect,
    Divider,
    Drawer,
    FormLabel,
    IconButton,
    Input,
    Link,
    List,
    Menu: Menu2,
    Modal,
    MultiSelect,
    Popover,
    Progress,
    Radio,
    Select: Select2,
    Stat,
    Switch,
    Table,
    Tabs,
    Text,
    Textarea
  },
  shadows: {
    outline: "none"
  }
});
export {
  Shadow1,
  borderColor,
  errorBoxShadow,
  focusedBoxShadow,
  inputBorderRadius,
  internalBorder,
  internalBorderColor,
  standardBorder,
  standardHoverBackground,
  theme4 as theme
};
//# sourceMappingURL=index.js.map